"use strict";
document.body.oncontextmenu = function(e) {
    return e.preventDefault();
};
var firstPromise = new Promise(function(resolve, reject) {
    var timeOutId = setTimeout(function() {
        reject(new Error("First promise was rejected"));
    }, 3000);
    document.body.addEventListener("click", function(e) {
        if (e.button === 0) {
            clearTimeout(timeOutId);
            resolve("First promise was resolved");
        }
    }, {
        once: true
    });
});
var secondPromise = new Promise(function(resolve) {
    document.body.addEventListener("mousedown", function(e) {
        if (e.button === 0 || e.button === 2) resolve("Second promise was resolved");
    });
});
var thirdPromise = new Promise(function(resolve) {
    var wasClickLeft = false;
    var wasClickRight = false;
    document.body.addEventListener("mousedown", function(e) {
        if (e.button === 0) wasClickLeft = true;
        if (e.button === 2) wasClickRight = true;
        if (wasClickLeft && wasClickRight) resolve("Third promise was resolved");
    });
});
firstPromise.then(success).catch(function(err) {
    return error(err.message);
});
secondPromise.then(success);
thirdPromise.then(success);
function success(msg) {
    var not = document.createElement("div");
    not.classList.add("success");
    not.dataset.qa = "notification";
    not.textContent = msg;
    document.body.append(not);
}
function error(msg) {
    var not = document.createElement("div");
    not.classList.add("error");
    not.dataset.qa = "notification";
    not.textContent = msg;
    document.body.append(not);
}

//# sourceMappingURL=index.9e2abb66.js.map
